import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import { useShopFlag } from "@/hooks/use-flag.ts";
import { useViewerHasAtLeastCustomerSupportRights } from "@/lib/rights/use-viewer-has-right.ts";
import useTranslation from "@babackapp/translations/use-translation";
import { GiftIcon, SparklesIcon } from "@heroicons/react/24/solid";
import { HomeIcon } from "@radix-ui/react-icons";
import { AlignEndHorizontal, GridIcon, ReplyIcon } from "lucide-react";
import { NavigationSectionItem } from "./section.tsx";

export default function PrimaryNavigation() {
  const { data: shop } = useCurrentShopSuspense();
  const t = useTranslation();
  const isAskEnabled = useShopFlag("isAskEnabled");
  const isOperationalDashboardEnabled = useShopFlag(
    "isOperationalDashboardEnabled",
  );
  const hasAtLeastCustomerSupportRight =
    useViewerHasAtLeastCustomerSupportRights();

  if (!shop) return null;

  const navigation = [
    {
      name: t("sidebar.home"),
      href: `/shops/${shop.id}`,
      icon: <HomeIcon className="w-4 h-4" />,
      display: true,
    },
    {
      name: t("sidebar.returns"),
      href: `/shops/${shop.id}/returns`,
      icon: <ReplyIcon className="w-4 h-4" />,
      display: true,
    },
    {
      name: t("sidebar.operational"),
      href: `/shops/${shop.id}/operations`,
      icon: <AlignEndHorizontal className="w-4 h-4" />,
      display: isOperationalDashboardEnabled,
    },
    {
      name: t("sidebar.ask"),
      href: `/shops/${shop.id}/ask`,
      icon: <SparklesIcon className="w-4 h-4" />,
      display: isAskEnabled,
    },
    {
      name: t("sidebar.giftCode"),
      href: `/shops/${shop.id}/gift-codes`,
      icon: <GiftIcon className="w-4 h-4" />,
      display: shop?.giftCode?.activated ?? false,
    },
    {
      name: t("sidebar.automations"),
      href: `/shops/${shop.id}/workflows`,
      icon: <GridIcon className="w-4 h-4" />,
      display: hasAtLeastCustomerSupportRight,
    },
  ].filter((navItem) => navItem.display);

  return (
    <>
      {navigation.map((navItem) => (
        <NavigationSectionItem
          key={navItem.name}
          to={navItem.href}
          label={navItem.name}
          icon={navItem.icon}
        />
      ))}
    </>
  );
}
